<script>
  import { mapState } from 'vuex';
  import Search from '@/assets/search.svg';
  import FinancierInput from '@/components/Financier/Input';

  export default {
    components: {
      FinancierInput,
    },

    data: () => ({
      filters: {
        date: '',
        coin: '',
        search: '',
        category: '',
      },
    }),

    computed: {
      ...mapState('coins', [
        'coins',
      ]),

      search () {
        return {
          type: 'text',
          label: 'Pesquisar',
          icon: Search,
        };
      },

      category () {
        return {
          label: 'Categoria',
          type: 'select',
          options: [
            {
              value: 0,
              label: 'Foo',
            },
          ],
        };
      },

      coin () {
        return {
          label: 'Moeda',
          type: 'select',
          options: this.coins.map(({ title: label, initial: value }) => ({ label, value })),
        };
      },

      date () {
        return {
          type: 'date',
          label: 'Data',
          allowed_dates: [
            1564714800000, 1564801200000, 1564887600000, 1565146800000, 1565233200000,
          ],
        };
      },
    },
  };
</script>

<template>
  <main class="financier-extract">
    <h1 class="sidebar__title">Extrato</h1>

    <div class="sidebar__header">
      <FinancierInput
        v-bind="search"
        v-model="filters.search"
        />

      <FinancierInput
        v-bind="date"
        v-model="filters.date"
        />

      <FinancierInput
        v-bind="coin"
        v-model="filters.coin"
        />

      <FinancierInput
        v-bind="category"
        v-model="filters.category"
        />

      <button class="financier-extract__action">
        Exportar
      </button>
    </div>

    <article
      :key="index"
      v-for="index in 3"
      class="financier-extract__item"
      >
      <h2 class="financier-extract__item-title">
        <span>02/05/19 Quarta-feira</span>
      </h2>

      <table class="financier-extract__table">
        <thead class="financier-extract__table-header">
          <tr class="financier-extract__table-header-row">
            <th class="financier-extract__table-header-item">Moeda</th>
            <th class="financier-extract__table-header-item">Categoria</th>
            <th class="financier-extract__table-header-item" width="15%">Valor</th>
            <th class="financier-extract__table-header-item" width="20%">Saldo após</th>
          </tr>
        </thead>

        <tbody class="financier-extract__table-body">
          <tr
            :key="initial"
            class="financier-extract__table-body-row"
            v-for="({ initial, color }, i) in coins"
            >

            <td
              v-text="initial"
              :style="{ color }"
              class="financier-extract__table-body-item financier-extract__table-initial"
              >
            </td>

            <td class="financier-extract__table-body-item">Operação de compra</td>

            <td
              v-text="i % 3 ? '+345,41' : '-255,32'"
              class="financier-extract__table-body-item"
              :class="i % 3 ? 'financier-extract__table-value--positive' : 'financier-extract__table-value--negative'"
              >
            </td>

            <td class="financier-extract__table-body-item financier-extract__table-balance">
              R$ 32.345,45
            </td>
          </tr>
        </tbody>
      </table>
    </article>
  </main>
</template>

<style lang="scss">
  .financier-extract {
    &__action {
      color: #FFF;
      margin-left: auto;
      padding: 12px 24px;
      border-radius: 4px;
      letter-spacing: .32px;
      background-color: #3e388b;

      &:hover {
        background-color: #322c76;
      }
    }

    &__item {
      &:not(:last-child) {
        margin-bottom: 56px;
        border-bottom: 1px solid rgba(#939cac, .15);
      }

      &-title {
        width: 100%;
        display: flex;
        margin-bottom: 36px;
        justify-content: center;
        border-bottom: 1px solid rgba(#939cac, .34);

        span {
          width: 200px;
          height: 32px;
          display: flex;
          font-size: 14px;
          line-height: 1.14;
          border-radius: 4px;
          align-items: center;
          margin-bottom: -16px;
          color: rgba(#FFF, .8);
          justify-content: center;
          background-color: #22223b;
          border: 1px solid rgba(#FFF, .21);
        }
      }
    }

    &__table {
      width: 100%;
      text-align: left;
      border-spacing: 0;

      &-header-item {
        color: #8e95a9;
        font-weight: 300;
        line-height: 1.25;
        padding: 16px 24px;
        letter-spacing: .32px;
      }

      &-body {
        color: #b2b8c5;
        font-size: 14px;
        line-height: 1.14;
        letter-spacing: .28px;

        &-row:nth-child(odd) {
          background-color: rgba(#14162f, .3);
        }

        &-item {
          padding: 16px 24px;
        }
      }

      &-initial {
        font-size: 16px;
      }

      &-balance {
        color: #FFF;
      }

      &-value {
        &--positive {
          color: #60c100;
        }

        &--negative {
          color: #ff001f;
        }
      }
    }
  }
</style>
